module.exports = __webpack_public_path__ + "media/OurLocation.bd3a8014.mp4";